import "../lib/common";
import "../lib/financials";
import "../lib/kartes";
import { DEVELOPMENT } from "../constants";

if (process.env.NODE_ENV === DEVELOPMENT) {
  console.log("--- loaded karte");
}
